// Client-side image normalisation:
// - Accepts any image the browser can decode (jpg/png/webp/heic where iOS Safari supports it).
// - Re-encodes as JPEG so backend storage gets a clean, predictable file.
// - Resizes the long edge to maxEdge (default 1600px). Keeps the aspect ratio.
// - Targets jpegQuality (default 0.85). Returns a File the existing /api/upload endpoint accepts.
export const resizeImage = (file, { maxEdge = 1600, jpegQuality = 0.85 } = {}) =>
  new Promise((resolve, reject) => {
    if (!file) return reject(new Error("No file"));
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error("Read failed"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Could not decode image"));
      img.onload = () => {
        let { width, height } = img;
        if (width > maxEdge || height > maxEdge) {
          const scale = maxEdge / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Encode failed"));
            const base = (file.name || "photo").replace(/\.[^.]+$/, "");
            resolve(new File([blob], `${base}.jpg`, { type: "image/jpeg" }));
          },
          "image/jpeg",
          jpegQuality
        );
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
